import type {
	HelpCenterArticle,
	HelpCenterArticleTranslation,
	HelpCenterGroup,
	HelpCenterGroupTranslation,
} from "@productlane/zero"

export type ArticleWithTranslations = HelpCenterArticle & {
	translations?: readonly HelpCenterArticleTranslation[]
}

export type ArticleWithSubpages = ArticleWithTranslations & {
	subpages?: readonly ArticleWithTranslations[]
}

export type GroupWithArticles = HelpCenterGroup & {
	helpCenterArticles: readonly ArticleWithSubpages[]
	translations?: readonly HelpCenterGroupTranslation[]
}

export type DragItem =
	| {
			type: "article"
			groupId: string
			parentArticleId: string | null
			article: HelpCenterArticle
	  }
	| {
			type: "group"
			group: HelpCenterGroup
	  }

// A group header is a drop target of its own: an article dropped on it leaves
// the group for the top level of the tree.
export interface GroupHeaderDropTarget {
	type: "group-header"
	group: HelpCenterGroup
}

export const groupHeaderDropId = (groupId: string) => `header:${groupId}`
